<template>
  <div>
    <app-spinner v-if="!is_loaded" />
    <template v-else>
      <app-cells>
        <h1 class="title">Land purchase contract (ID: {{ form.id }})</h1>
        <app-checkbox v-model="form.confirmed" @change="onToggleConfirmed" label="Confirmed" />
      </app-cells>
      <form @submit.prevent="onCheckForm" class="contract-form">
        <app-grid>
          <template #item-1>
            <app-form-group label="Main seller" label-for="main_seller" required>
              <app-input
                v-model="form.main_seller"
                :error="$v.form.main_seller.$error"
                id="main_seller"
                placeholder="Main seller"
                name="main_seller"
              />
              <template #error>
                <div v-if="$v.form.main_seller.$dirty && !$v.form.main_seller.required">Required field</div>
              </template>
            </app-form-group>
            <app-form-group label="Second seller" label-for="second_seller">
              <app-input
                v-model="form.second_seller"
                id="second_seller"
                placeholder="Second seller"
                name="second_seller"
              />
            </app-form-group>
            <app-form-group label="Date" label-for="date">
              <app-input
                v-model="form.date"
                id="date"
                placeholder="Date"
                name="date"
              />
            </app-form-group>
            <app-form-group label="Main seller ID" label-for="main_seller_id">
              <app-input
                v-model="form.main_seller_id"
                id="main_seller_id"
                placeholder="Main seller ID"
                name="main_seller_id"
              />
            </app-form-group>
            <app-form-group label="Plot Meters West" label-for="plot_meters_west">
              <app-input
                v-model="form.plot_meters_west"
                id="plot_meters_west"
                placeholder="Plot Meters West"
                name="plot_meters_west"
              />
            </app-form-group>
            <app-form-group label="Plot Meters South" label-for="plot_meters_south">
              <app-input
                v-model="form.plot_meters_south"
                id="plot_meters_south"
                placeholder="Plot Meters South"
                name="plot_meters_south"
              />
            </app-form-group>
            <app-form-group label="Plot Meters East" label-for="plot_meters_east">
              <app-input
                v-model="form.plot_meters_east"
                id="plot_meters_east"
                placeholder="Plot Meters East"
                name="plot_meters_east"
              />
            </app-form-group>
            <app-form-group label="Plot Meters North" label-for="plot_meters_north">
              <app-input
                v-model="form.plot_meters_north"
                id="plot_meters_north"
                placeholder="Plot Meters North"
                name="plot_meters_north"
              />
            </app-form-group>
            <app-form-group label="Land Village" label-for="land_village">
              <app-input
                v-model="form.land_village"
                id="land_village"
                placeholder="Land Village"
                name="land_village"
              />
            </app-form-group>
            <app-form-group label="Land District" label-for="land_district">
              <app-input
                v-model="form.land_district"
                id="land_district"
                placeholder="Land District"
                name="land_district"
              />
            </app-form-group>
            <app-form-group label="Land Region" label-for="land_region">
              <app-input
                v-model="form.land_region"
                id="land_region"
                placeholder="Land Region"
                name="land_region"
              />
            </app-form-group>
            <app-form-group label="GPS Coordinate 1" label-for="gps_coordinate_1">
              <app-input
                v-model="form.gps_coordinate_1"
                id="gps_coordinate_1"
                placeholder="GPS Coordinate 1"
                name="gps_coordinate_1"
              />
            </app-form-group>
            <app-form-group label="GPS Coordinate 2" label-for="gps_coordinate_2">
              <app-input
                v-model="form.gps_coordinate_2"
                id="gps_coordinate_2"
                placeholder="GPS Coordinate 2"
                name="gps_coordinate_2"
              />
            </app-form-group>
            <app-form-group label="GPS Coordinate 3" label-for="gps_coordinate_3">
              <app-input
                v-model="form.gps_coordinate_3"
                id="gps_coordinate_3"
                placeholder="GPS Coordinate 3"
                name="gps_coordinate_3"
              />
            </app-form-group>
            <app-form-group label="GPS Coordinate 4" label-for="gps_coordinate_4">
              <app-input
                v-model="form.gps_coordinate_4"
                id="gps_coordinate_4"
                placeholder="GPS Coordinate 4"
                name="gps_coordinate_4"
              />
            </app-form-group>
            <app-form-group label="GPS Coordinate 5" label-for="gps_coordinate_5">
              <app-input
                v-model="form.gps_coordinate_5"
                id="gps_coordinate_5"
                placeholder="GPS Coordinate 5"
                name="gps_coordinate_5"
              />
            </app-form-group>
            <app-form-group label="GPS Coordinate 6" label-for="gps_coordinate_6">
              <app-input
                v-model="form.gps_coordinate_6"
                id="gps_coordinate_6"
                placeholder="GPS Coordinate 6"
                name="gps_coordinate_6"
              />
            </app-form-group>
          </template>
          <template #item-2>
            <app-form-group label="Neighbor East" label-for="neighbor_east">
              <app-input
                v-model="form.neighbor_east"
                id="neighbor_east"
                placeholder="Neighbor East"
                name="neighbor_east"
              />
            </app-form-group>
            <app-form-group label="Neighbor West" label-for="neighbor_west">
              <app-input
                v-model="form.neighbor_west"
                id="neighbor_west"
                placeholder="Neighbor West"
                name="neighbor_west"
              />
            </app-form-group>
            <app-form-group label="Neighbor North" label-for="neighbor_north">
              <app-input
                v-model="form.neighbor_north"
                id="neighbor_north"
                placeholder="Neighbor North"
                name="neighbor_north"
              />
            </app-form-group>
            <app-form-group label="Neighbor South" label-for="neighbor_south">
              <app-input
                v-model="form.neighbor_south"
                id="neighbor_south"
                placeholder="Neighbor South"
                name="neighbor_south"
              />
            </app-form-group>
            <app-form-group label="Land Price Amount" label-for="land_price_amount">
              <app-input
                v-model.number="form.land_price_amount"
                id="land_price_amount"
                placeholder="0"
                name="land_price_amount"
                type="number"
              />
            </app-form-group>
            <app-form-group label="Price in words" label-for="price_words">
              <app-input
                v-model="form.price_in_words"
                id="price_words"
                placeholder="Price in words"
                name="price_words"
              />
            </app-form-group>
            <app-form-group label="Seller Bank" label-for="seller_bank">
              <app-input
                v-model="form.seller_bank"
                id="seller_bank"
                placeholder="Seller Bank"
                name="seller_bank"
              />
            </app-form-group>
            <app-form-group label="Seller Bank Account" label-for="seller_bank_account">
              <app-input
                v-model="form.seller_bank_account"
                id="seller_bank_account"
                placeholder="Seller Bank Account"
                name="seller_bank_account"
              />
            </app-form-group>
            <app-form-group label="Seller Account Name" label-for="seller_account_name">
              <app-input
                v-model="form.seller_account_name"
                id="seller_account_name"
                placeholder="Seller Account Name"
                name="seller_account_name"
              />
            </app-form-group>
            <app-form-group label="Seller Relationship" label-for="seller_relationship">
              <app-input
                v-model="form.seller_relationship"
                id="seller_relationship"
                placeholder="Seller Relationship"
                name="seller_relationship"
              />
            </app-form-group>
            <app-form-group label="Main seller attachment">
              <app-cropper-web-cam
                v-model="form.main_seller_attachment"
                ref="cropper"
                modalName="modal"
              >
                <template #title>Upload photo</template>
                <template #text>
                  <ul>
                    <li>Accepted formats: JPG, JPEG, BMP, PNG, TIFF, TIF</li>
                    <li>Maximum size: 5 MB</li>
                  </ul>
                </template>
              </app-cropper-web-cam>
            </app-form-group>
            <app-form-group label="Second seller attachment">
              <app-cropper-web-cam
                v-model="form.second_seller_attachment"
                ref="cropper_second"
                modalName="modal-second"
              >
                <template #title>Upload photo</template>
                <template #text>
                  <ul>
                    <li>Accepted formats: JPG, JPEG, BMP, PNG, TIFF, TIF</li>
                    <li>Maximum size: 5 MB</li>
                  </ul>
                </template>
              </app-cropper-web-cam>
            </app-form-group>
          </template>
        </app-grid>
        <app-cells position="end" :indent="false">
          <app-button @click.native="onDownloadContract" ref="download" theme="warn">Download</app-button>
          <app-button :disabled="$v.form.$error" type="submit" ref="submit">Save contract</app-button>
        </app-cells>
      </form>
    </template>
  </div>
</template>

<script>

import { getLandPurchaseContract, getLandPurchaseContractExport, patchLandPurchaseContract } from '@/http'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'LandPurchaseContractDetail',
  data() {
    return {
      is_loaded: false,
      form: {},
    }
  },
  validations: {
    form: {
      main_seller: { required },
    }
  },
  created() {
    this.getContractData()
  },
  methods: {
    getContractData() {
      getLandPurchaseContract(this.$route.params.id)
        .then(res => {
          this.form = res.data
          this.is_loaded = true
        })
    },
    onCheckForm() {
      this.$v.form.$touch()
      if (this.$v.form.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        if ((this.form.main_seller_attachment.coords && !this.form.main_seller_attachment.photo) || (this.form.second_seller_attachment.coords && !this.form.second_seller_attachment.photo)) {
          this.$refs.submit.preload = true
          if ((this.form.main_seller_attachment.coords && !this.form.main_seller_attachment.photo) && (this.form.second_seller_attachment.coords && !this.form.second_seller_attachment.photo)) {
            Promise.all([this.$refs.cropper.sendCrop(), this.$refs.cropper_second.sendCrop()])
              .then(() => { this.sendForm() })
              .catch(() => { this.$refs.submit.preload = false })
          } else {
            if (this.form.main_seller_attachment.coords && !this.form.main_seller_attachment.photo) {
              this.$refs.cropper.sendCrop()
                .then(() => { this.sendForm() })
                .catch(() => { this.$refs.submit.preload = false })
            }
            if (this.form.second_seller_attachment.coords && !this.form.second_seller_attachment.photo) {
              this.$refs.cropper_second.sendCrop()
                .then(() => { this.sendForm() })
                .catch(() => { this.$refs.submit.preload = false })
            }
          }
        } else {
          this.sendForm()
        }
      }
    },
    sendForm() {
      this.$refs.submit.preload = true
      patchLandPurchaseContract(this.$route.params.id, this.form)
        .finally(() => { this.$refs.submit.preload = false })
        .then(() => {
          this.$notify({
            type: 'success',
            title: 'Contract saved',
          })
          this.getContractData()
        })
    },
    onToggleConfirmed() {
      patchLandPurchaseContract(this.$route.params.id, {confirmed: this.form.confirmed})
        .then(() => {
          this.$notify({
            type: 'success',
            title: 'Contract saved',
          })
          this.getContractData()
        })
    },
    onDownloadContract() {
      this.$refs.download.preload = true
      getLandPurchaseContractExport(+this.$route.params.id)
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', `Land purchase contract - ${this.$route.params.id}.docx`)
          document.body.appendChild(link)
          link.click()
          URL.revokeObjectURL(url)
          this.$refs.download.preload = false
        })
        .catch(() => { this.$refs.download.preload = false })
    }
  }
}
</script>

<style scoped lang="sass">
.contract-form
  max-width: 800px
</style>
